import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { graphql, compose, withApollo } from 'react-apollo'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
  NavLink
} from 'react-router-dom'
import { Dropdown, Layout, Menu, Icon, Avatar, Spin } from 'antd'
import HeroNews from './HeroNews'

import Login from './Login'
import Dashboard from './Dashboard'
import Documents from './Documents'
import Users from './Users'
import Logs from './Logs'
import HeroConfig from './HeroConfig'
import Heroes from './Heroes'
import Brands from './Brand'
import Category from './Category'
import CategoryEquipment from './CategoryEquipment'
import Equipment from './Equipment'
import Seller from './Seller'
import Quotation from './Quotation'
import Material from './Material'
import Account from './Account'
import Step from './Step'
import StepType from './StepType'
import AppUsers from './AppUsers'
import PresetGroup from './PresetGroup'
import PresetCategory from './PresetCategory'
import Preset from './Preset'
import ProductFeature from './ProductFeature'
import BarcodeProduct from './BarcodeProduct'
import BarcodeProductCategory from './BarcodeProductCategory'
import RecycleBarcodeProduct from './RecycleBarcodeProduct'
import News from './News'
import Reward from './Reward'
import RedeemTransaction from './RedeemTransaction'
import PointTransaction from './PointTransaction'
import PointGainType from './PointGainType'
import UserPoint from './UserPoint'
import Banners from './Banners'
import Bin from './Bin'
import Delay from './Delay'
import ForceUpdate from './ForceUpdate'
import ReportProblem from './ReportProblem'
import UserAnnouncement from './UserAnnouncement'
import HeroPromote from './HeroPromote'
import Notification from './Notification'

import Version from '../components/Version'

import { GET_USER_AUTHENTICATED } from '../graphql/queries'
import { styles, MenuWrapper, Logo, Centered } from './styles'
import MaterialLink from './MaterialLink'
import Reports from './Reports'
import Transaction from './Transaction'

const { Header, Sider, Content } = Layout
const logo = require('../assets/images/logo-inverse.png')
const g2gLogo = require('../assets/images/g2g.png')

export class App extends Component {
  constructor() {
    super()

    this.state = {
      collapsed: false
    }

    this.toggle = this.toggle.bind(this)
    this.logout = this.logout.bind(this)
    this.menu = this.menu.bind(this)
  }

  toggle() {
    this.setState((prevState) => ({
      collapsed: !prevState.collapsed
    }))
  }

  logout() {
    const { client } = this.props

    localStorage.removeItem('user-token')
    localStorage.removeItem('g2g-token')

    client.resetStore()
  }

  menu() {
    return (
      <Menu>
        <Menu.Item>
          <NavLink to="/account">
            <Icon type="user" style={{ marginRight: '8px' }} />
            Account
          </NavLink>
        </Menu.Item>
        <Menu.Item onClick={() => this.logout()}>
          <Icon type="poweroff" />
          Logout
        </Menu.Item>
      </Menu>
    )
  }

  render() {
    const { collapsed } = this.state
    const { data } = this.props

    if (!data.loading) {
      return (
        <Router>
          {data.me && data.me.id && data.me.role === 'ADMIN' ? (
            <Layout style={{ minHeight: '100vh' }}>
              <Sider
                trigger={null}
                collapsible
                collapsed={collapsed}
                width={250}>
                <Logo style={{ backgroundColor: '#001529' }}>
                  {collapsed ? (
                    <img src={g2gLogo} width="20" alt="Full width logo" />
                  ) : (
                    <img src={logo} width="120" alt="Logo" />
                  )}
                </Logo>
                <Menu theme="dark" mode="inline" defaultSelectedKeys={['1']}>
                  <Menu.Item key="1">
                    <NavLink to="/">
                      <Icon type="home" />
                      <span>Dashboard</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.SubMenu
                    key="brands"
                    title={
                      <span>
                        <Icon type="tag" />
                        <span>Brands</span>
                      </span>
                    }>
                    <Menu.Item key="brands">
                      <NavLink to="/brands">
                        <span>Brands</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="product-feature">
                      <NavLink to="/product-feature">
                        <span>Product Feature</span>
                      </NavLink>
                    </Menu.Item>
                  </Menu.SubMenu>
                  <Menu.Item key="app-users">
                    <NavLink to="/app-users">
                      <Icon type="user" />
                      <span>App Users</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.SubMenu
                    key="hero"
                    title={
                      <span>
                        <Icon type="team" />
                        <span>Heroes</span>
                      </span>
                    }>
                    <Menu.Item key="heroes">
                      <NavLink to="/heroes">
                        <span>Heroes</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="documents">
                      <NavLink to="/documents">
                        <span>Documents</span>
                      </NavLink>
                    </Menu.Item>
                  </Menu.SubMenu>
                  <Menu.SubMenu
                    key="products"
                    title={
                      <span>
                        <Icon type="rest" />
                        <span>Products</span>
                      </span>
                    }>
                    <Menu.Item key="material-category">
                      <NavLink to="/category">
                        <span>Product Category</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="material">
                      <NavLink to="/material">
                        <span>Product List</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="material-link">
                      <NavLink to="/material-link">
                        <span>Product Link</span>
                      </NavLink>
                    </Menu.Item>
                  </Menu.SubMenu>
                  <Menu.SubMenu
                    key="step"
                    title={
                      <span>
                        <Icon type="tags" />
                        <span>Steps</span>
                      </span>
                    }>
                    <Menu.Item key="stepType-list">
                      <NavLink to="/stepType">
                        <span>Step Type List</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="step-list">
                      <NavLink to="/step">
                        <span>Step List</span>
                      </NavLink>
                    </Menu.Item>
                  </Menu.SubMenu>
                  <Menu.SubMenu
                    key="preset"
                    title={
                      <span>
                        <Icon type="container" />
                        <span>Preset</span>
                      </span>
                    }>
                    {/* <Menu.Item key="preset-groups">
                      <NavLink to="/presetGroup">
                        <span>Preset Group List</span>
                      </NavLink>
                    </Menu.Item> */}
                    <Menu.Item key="preset-Category">
                      <NavLink to="/presetCategory">
                        <span>Preset Category List</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="preset-list">
                      <NavLink to="/preset">
                        <span>Preset List</span>
                      </NavLink>
                    </Menu.Item>
                  </Menu.SubMenu>
                  <Menu.SubMenu
                    key="barcode-product"
                    title={
                      <span>
                        <Icon type="barcode" />
                        <span>Barcode Product</span>
                      </span>
                    }>
                    <Menu.Item key="barcode-product-category">
                      <NavLink to="/barcodeProductCategory">
                        <span>Barcode Product Category List</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="barcode-product-list">
                      <NavLink to="/barcodeProduct">
                        <span>Barcode Product List</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="recycle-barcode-product-list">
                      <NavLink to="/recycleBarcodeProduct">
                        <span>Recycle Barcode Product List</span>
                      </NavLink>
                    </Menu.Item>
                  </Menu.SubMenu>
                  <Menu.SubMenu
                    key="equipment"
                    title={
                      <span>
                        <Icon type="tool" />
                        <span>Equipment</span>
                      </span>
                    }>
                    <Menu.Item key="category-equipment">
                      <NavLink to="/category-equipment">
                        <span>Equipment Category</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="equipment">
                      <NavLink to="/equipment">
                        <span>Equipment</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="seller">
                      <NavLink to="/seller">
                        <span>Seller</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="quotation">
                      <NavLink to="/quotation">
                        <span>Quotation</span>
                      </NavLink>
                    </Menu.Item>
                  </Menu.SubMenu>
                  <Menu.SubMenu
                    key="news"
                    title={
                      <span>
                        <Icon type="sound" />
                        <span>News</span>
                      </span>
                    }>
                  <Menu.Item key="news">
                    <NavLink to="/news">
                      <span>Users News</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="heroNews">
                    <NavLink to="/hero-news">
                      <span>Hero News</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="banners">
                    <NavLink to="/banners">
                      <span>Banners</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="notification">
                    <NavLink to="/notification">
                      <span>Notification</span>
                    </NavLink>
                  </Menu.Item>
                  </Menu.SubMenu>
                  <Menu.SubMenu
                    key="reward"
                    title={
                      <span>
                        <Icon type="gift" />
                        <span>Reward</span>
                      </span>
                    }>
                  <Menu.Item key="reward">
                    <NavLink to="/reward">
                      <span>Reward</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="RedeemTransaction">
                    <NavLink to="/redeem-transaction">
                      <span>Redeem Transaction</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="PointTransaction">
                    <NavLink to="/point-transaction">
                      <span>Point Transaction</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="PointGainType">
                    <NavLink to="/point-gain-type">
                      <span>Point Gain Type</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="userPoint">
                    <NavLink to="/user-point">
                      <span>User Point</span>
                    </NavLink>
                  </Menu.Item>
                  </Menu.SubMenu>
                  <Menu.Item key="bin">
                    <NavLink to="/bin">
                      <Icon type="delete" />
                      <span>Circular Bin</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.SubMenu
                    key="reports"
                    title={
                      <span>
                        <Icon type="bar-chart" />
                        <span>Reports</span>
                      </span>
                    }>
                    <Menu.Item key="circularbin">
                      <NavLink to="/reports">
                        <span>Circular Bin</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="transaction">
                      <NavLink to="/transaction">
                        <span>Transaction</span>
                      </NavLink>
                    </Menu.Item>
                  </Menu.SubMenu>
                  <Menu.Item key="user-announcement">
                    <NavLink to="/user-announcement">
                      <Icon type="notification" />
                      <span>User Announcement</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="heroPromote">
                    <NavLink to="/heroPromote">
                      <Icon type="notification" />
                      <span>Hero Promote</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.SubMenu
                    key="settings"
                    title={
                      <span>
                        <Icon type="setting" />
                        <span>Settings</span>
                      </span>
                    }>
                    <Menu.Item key="force-update">
                      <NavLink to="/force-update">
                        <span>Force Update</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="report-problem">
                      <NavLink to="/report-problem">
                        <span>Report Problem</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="delay">
                      <NavLink to="/delay">
                        <span>Transaction Delay</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="users">
                      <NavLink to="/users">
                        <span>Users</span>
                      </NavLink>
                    </Menu.Item>

                    <Menu.Item key="heroConfig">
                      <NavLink to="/heroConfig">
                        <span>Heroes</span>
                      </NavLink>
                    </Menu.Item>

                    <Menu.Item key="logs">
                      <NavLink to="/logs">
                        <span>Logs</span>
                      </NavLink>
                    </Menu.Item>
                  </Menu.SubMenu>

                  <Version color="grey" />
                </Menu>
              </Sider>
              <Layout>
                <Header style={{ background: '#fff', padding: 0 }}>
                  <Icon
                    style={{ padding: '0 24px' }}
                    className="trigger"
                    type={collapsed ? 'menu-unfold' : 'menu-fold'}
                    onClick={this.toggle}
                  />
                  <MenuWrapper>
                    <Dropdown
                      overlay={this.menu}
                      placement="topRight"
                      trigger={['click']}>
                      <a href="/">
                        <React.Fragment>
                          {data.me.username}
                          <Avatar
                            src={data.me.avatar}
                            style={{ marginLeft: '8px' }}
                          />
                        </React.Fragment>
                      </a>
                    </Dropdown>
                  </MenuWrapper>
                </Header>
                <Content style={styles.content}>
                  <Switch>
                    <Route exact path="/" component={Dashboard} />
                    <Route exact path="/users" component={Users} />
                    <Route exact path="/logs" component={Logs} />
                    <Route exact path="/heroConfig" component={HeroConfig} />
                    <Route exact path="/heroes" component={Heroes} />
                    <Route exact path="/app-users" component={AppUsers} />
                    <Route exact path="/documents" component={Documents} />
                    <Route exact path="/brands" component={Brands} />
                    <Route
                      exact
                      path="/user-announcement"
                      component={UserAnnouncement}
                    />
                    <Route
                      exact
                      path="/heroPromote"
                      component={HeroPromote}
                    />
                    <Route
                      exact
                      path="/notification"
                      component={Notification}
                    />
                    <Route exact path="/category" component={Category} />
                    <Route exact path="/material" component={Material} />
                    <Route
                      exact
                      path="/material-link"
                      component={MaterialLink}
                    />

                    <Route exact path="/category-equipment" component={CategoryEquipment} />
                    <Route exact path="/equipment" component={Equipment} />
                    <Route exact path="/seller" component={Seller} />
                    <Route exact path="/quotation" component={Quotation} />

                    <Route
                      exact
                      path="/product-feature"
                      component={ProductFeature}
                    />
                    <Route exact path="/step" component={Step} />
                    <Route exact path="/stepType" component={StepType} />
                    {/* <Route exact path="/presetGroup" component={PresetGroup} /> */}
                    <Route exact path="/preset" component={Preset} />
                    <Route exact path="/reports" component={Reports} />
                    <Route exact path="/transaction" component={Transaction} />
                    <Route exact path="/delay" component={Delay} />
                    <Route exact path="/force-update" component={ForceUpdate} />
                    <Route
                      exact
                      path="/report-problem"
                      component={ReportProblem}
                    />
                    <Route
                      exact
                      path="/PresetCategory"
                      component={PresetCategory}
                    />
                    <Route
                      exact
                      path="/barcodeProduct"
                      component={BarcodeProduct}
                    />
                    <Route
                      exact
                      path="/barcodeProductCategory"
                      component={BarcodeProductCategory}
                    />
                    <Route
                      exact
                      path="/recycleBarcodeProduct"
                      component={RecycleBarcodeProduct}
                    />
                    <Route exact path="/news" component={News} />
                    <Route exact path="/hero-news" component={HeroNews} />
                    <Route exact path="/banners" component={Banners} />

                    <Route exact path="/reward" component={Reward} />
                    <Route exact path="/redeem-transaction" component={RedeemTransaction} />
                    <Route exact path="/point-transaction" component={PointTransaction} />
                    <Route exact path="/point-gain-type" component={PointGainType} />
                    <Route exact path="/user-point" component={UserPoint} />

                    <Route exact path="/bin" component={Bin} />

                    <Route
                      exact
                      path="/account"
                      render={(props) => <Account {...props} {...this.props} />}
                    />

                    <Redirect from="*" to="/" />
                  </Switch>
                </Content>
              </Layout>
            </Layout>
          ) : (
            <Switch>
              <Route exact path="/" component={Login} />
              <Redirect from="*" to="/" />
            </Switch>
          )}
        </Router>
      )
    } else {
      return (
        <Centered>
          <Spin size="large" />
        </Centered>
      )
    }
  }
}

App.propTypes = {
  data: PropTypes.object.isRequired,
  client: PropTypes.object.isRequired
}

export default compose(withApollo, graphql(GET_USER_AUTHENTICATED))(App)



// WEBPACK FOOTER //
// ./src/pages/App.js